<template>
	<div id="home_page" class="homepage bg-color-light">
		<div class="home-section">
			<div class="landingpage-1">
				<div class="css-tabs">
					<b-tabs content-class="" v-model="tabIndex">
						<b-tab title="Lớp 4" active>
							<div class="bg-color-hover">
								<div class="class-2" id="landingpage-1">
									<!-- <div  v-if="screenWidth > 991" class="class-2__image text-center">
										<img v-if="isShowImg === 1" src="@/assets/images/Banner_KNTT2.png" alt="">
										<img v-else-if="isShowImg === 2" src="@/assets/images/Banner_CTST2.png" alt="">
										<img v-else src="@/assets/images/Banner_HTS.png" alt="">
									</div>
									<div v-else class="class-2__image text-center">
										<img v-if="isShowImg === 1" src="@/assets/images/Banner Mobile_21.png" alt="">
										<img v-else-if="isShowImg === 2" src="@/assets/images/Banner Mobile_22.png" alt="">
										<img v-else src="@/assets/images/Banner Mobile_HTS.png" alt="">
									</div> -->
									<VueSlickCarousel v-bind="settings">
											<!-- <img  src="@/assets/images/lop4/slide1.jpg" alt=""> -->
											<img :src="`${cdnLinkBanner}Banner 4 KNTT.jpg`" alt="">
											<img :src="`${cdnLinkBanner}Banner 4 CTST.jpg`" alt="">
									</VueSlickCarousel>

									<!-- <h3 class="class-2__title text-center font-size-20 font-sanpro-semibold primary-color">
										Ảnh giới thiệu tổng quan sách lớp 2
									</h3>
									<h4 class="text-center font-size-16 font-sanpro-semibold secondary-color-txt">Khi chuột di đến bộ sách nào ở dưới, banner này sẽ chuyển sang ảnh hoặc video giới thiệu bộ sách tương ứng.</h4> -->
								</div>
							</div>
							<div class="books container-hts">
								<div class="display-flex justify-content-center book-group">
									<div class="books__info info-1 text-center" @mouseover="mouseOver1">
										<img class="books__image" src="@/assets/images/bg-book-2.png" alt="" @click="loginFast({ query: { classes: 8, book_active: 0 }})">
										<!-- <h3 class="books__title font-size-24 font-sanpro-semibold primary-color-txt">Kết nối tri thức với cuộc sống</h3> -->
										<h4 class="books_try">
											<button class="btn-try font-size-18 font-sanpro-semibold primary-color" @click="loginFast({ query: { classes: 8, book_active: 0 }})">
												Xem ngay
											</button>
										</h4>
									</div>
									<div class="books__info info-2 text-center" @mouseover="mouseOver2">
										<img class="books__image" src="@/assets/images/bg-book-1.png" alt="" @click="loginFast({ query: { classes: 8, book_active: 1 }})">
										<!-- <h3 class="books__title font-size-24 font-sanpro-semibold primary-color-txt">Chân trời sáng tạo</h3> -->
										<h4 class="books_try">
											<button class="btn-try font-size-18 font-sanpro-semibold primary-color" @click="loginFast({ query: { classes: 8, book_active: 1 }})">
												Xem ngay
											</button>
										</h4>
									</div>
								</div>
							</div>
						</b-tab>
						<b-tab title="Lớp 8">
								<div class="bg-color-hover">
								<div class="class-2">
									<!-- <div  v-if="screenWidth > 991" class="class-2__image text-center">
										<img v-if="isShowImg === 1" src="@/assets/images/Banner_KNTT6.png" alt="">
										<img v-else-if="isShowImg === 2" src="@/assets/images/Banner_CTST6.png" alt="">
										<img v-else src="@/assets/images/Banner_HTS.png" alt="">
									</div>

									<div v-else class="class-2__image text-center">
									    <img v-if="isShowImg === 1" src="@/assets/images/Banner Mobile_61.png" alt="">
										<img v-else-if="isShowImg === 2" src="@/assets/images/Banner Mobile_62.png" alt="">
										<img v-else src="@/assets/images/Banner Mobile_HTS.png" alt="">
									</div> -->

									<!-- <VueSlickCarousel v-bind="settings">
										<div  class="class-2__image text-center">
											<img  src="@/assets/images/lop8/slide1.jpg" alt="">
										</div>
										<div  class="class-2__image text-center">
											<img  src="@/assets/images/lop8/slide2.jpg" alt="">
										</div>
									</VueSlickCarousel> -->

									<VueSlickCarousel v-bind="settings">
										<img :src="`${cdnLinkBanner}Banner 8 KNTT.jpg`" alt="">
										<img :src="`${cdnLinkBanner}Banner 8 CTST.jpg`" alt="">
									</VueSlickCarousel>

									<!-- <h3 class="class-2__title text-center font-size-20 font-sanpro-semibold primary-color">
										Ảnh giới thiệu Hành trang số hoặc sách của NXB
									</h3>
									<h4 class="text-center font-size-16 font-sanpro-semibold secondary-color-txt">Khi chuột di đến bộ sách nào ở dưới, banner này sẽ chuyển sang ảnh hoặc video giới thiệu bộ sách tương ứng.</h4> -->
								</div>
							</div>
							<div class="books container-hts">
								<div class="display-flex justify-content-center book-group">
									<div class="books__info info-1 text-center" @mouseover="mouseOver1">
										<img class="books__image" src="@/assets/images/bg-book-2.png" alt="" @click="loginFast({ query: { classes: 12, book_active: 0 }})">
										<!-- <h3 class="books__title font-size-24 font-sanpro-semibold primary-color-txt">Kết nối tri thức với cuộc sống</h3> -->
										<h4 class="books_try">
											<button class="btn-try font-size-18 font-sanpro-semibold primary-color" @click="loginFast({ query: { classes: 12, book_active: 0 }})">
												Xem ngay
											</button>
										</h4>
									</div>
									<div class="books__info info-2 text-center" @mouseover="mouseOver2">
										<img class="books__image" src="@/assets/images/bg-book-1.png" alt="" @click="loginFast({ query: { classes: 12, book_active: 1 }})">
										<!-- <h3 class="books__title font-size-24 font-sanpro-semibold primary-color-txt">Chân trời sáng tạo</h3> -->
										<h4 class="books_try">
											<button class="btn-try font-size-18 font-sanpro-semibold primary-color" @click="loginFast({ query: { classes: 12, book_active: 1 }})">
												Xem ngay
											</button>
										</h4>
									</div>
								</div>
							</div>
						</b-tab>
						<b-tab title="Lớp 11">
								<div class="bg-color-hover">
								<div class="class-2">
									<!-- <div  v-if="screenWidth > 991" class="class-2__image text-center">
										<img v-if="isShowImg === 1" src="@/assets/images/Banner_KNTT6.png" alt="">
										<img v-else-if="isShowImg === 2" src="@/assets/images/Banner_CTST6.png" alt="">
										<img v-else src="@/assets/images/Banner_HTS.png" alt="">
									</div>

									<div v-else class="class-2__image text-center">
									    <img v-if="isShowImg === 1" src="@/assets/images/Banner Mobile_61.png" alt="">
										<img v-else-if="isShowImg === 2" src="@/assets/images/Banner Mobile_62.png" alt="">
										<img v-else src="@/assets/images/Banner Mobile_HTS.png" alt="">
									</div> -->

									<!-- <VueSlickCarousel v-bind="settings">
										<div  class="">
											<img  src="@/assets/images/lop11/slide1.jpg" alt="">
										</div>
										<div  class="">
											<img  src="@/assets/images/lop11/slide2.jpg" alt="">
										</div>
									</VueSlickCarousel> -->

									<VueSlickCarousel v-bind="settings">
										<img :src="`${cdnLinkBanner}Banner 11 KNTT.jpg`" alt="">
										<img :src="`${cdnLinkBanner}Banner 11 CTST.jpg`" alt="">
									</VueSlickCarousel>

									<!-- <h3 class="class-2__title text-center font-size-20 font-sanpro-semibold primary-color">
										Ảnh giới thiệu Hành trang số hoặc sách của NXB
									</h3>
									<h4 class="text-center font-size-16 font-sanpro-semibold secondary-color-txt">Khi chuột di đến bộ sách nào ở dưới, banner này sẽ chuyển sang ảnh hoặc video giới thiệu bộ sách tương ứng.</h4> -->
								</div>
							</div>
							<div class="books container-hts">
								<div class="display-flex justify-content-center book-group">
									<div class="books__info info-1 text-center" @mouseover="mouseOver1">
										<img class="books__image" src="@/assets/images/bg-book-2.png" alt="" @click="loginFast({ query: { classes: 15, book_active: 0 }})">
										<!-- <h3 class="books__title font-size-24 font-sanpro-semibold primary-color-txt">Kết nối tri thức với cuộc sống</h3> -->
										<h4 class="books_try">
											<button class="btn-try font-size-18 font-sanpro-semibold primary-color" @click="loginFast({ query: { classes: 15, book_active: 0 }})">
												Xem ngay
											</button>
										</h4>
									</div>
									<div class="books__info info-2 text-center" @mouseover="mouseOver2">
										<img class="books__image" src="@/assets/images/bg-book-1.png" alt="" @click="loginFast({ query: { classes: 15, book_active: 1 }})">
										<!-- <h3 class="books__title font-size-24 font-sanpro-semibold primary-color-txt">Chân trời sáng tạo</h3> -->
										<h4 class="books_try">
											<button class="btn-try font-size-18 font-sanpro-semibold primary-color" @click="loginFast({ query: { classes: 15, book_active: 1 }})">
												Xem ngay
											</button>
										</h4>
									</div>
								</div>
							</div>
						</b-tab>
					</b-tabs>
				</div>
				<div class="move">
					<button v-if="lastScrollPosition < 500" class="btn-move-down" @click="scrollToSection('home__training')">
						<i class="icon-arrow-down primary-color font-size-20"></i>
					</button>
					<button v-else class="btn-move-down" @click="scrollToSection('landingpage-1')">
						<i class="icon-arrow-up primary-color font-size-20"></i>
					</button>
				</div>
			</div>
		</div>
		<!-- <div class=" text-center home-arrow-box d-lg-block d-none">
			<a href="javascript:;" @click="scrollToSection('home__training')">
				<i class="icon-arrow-double-down font-size-72"/>
			</a>
		</div> -->
		<div id="home__training" class="home-section home-section__training">
			<div class="home-register__wrap display-flex">
				<div class="home-section__small display-flex-center justify-content-center">
					<div class="home-register__form">
						<div class="home-training__desc">
							<h2 class="home-register__desc__title font-size-26 primary-color-txt font-sanpro-semibold d-none d-lg-block">
								Nền tảng Tập huấn của Nhà xuất bản Giáo dục Việt Nam: Song hành cùng Hành trang số
							</h2>
							<h2 class="home-register__desc__title font-size-26 primary-color-txt font-sanpro-semibold d-lg-none text-center">
								Nền tảng Tập huấn song<br />
								hành với Hành trang số
							</h2>
							<div class="home-register__desc__content">
								<p class="margin-0 font-size-18 primary-color-txt font-sanpro-light text-justify">
									Tập huấn là nền tảng tập huấn giáo viên trực tuyến của Nhà xuất bản Giáo dục Việt Nam, phục vụ việc tiếp nhận tài liệu, thông tin...chính thống từ NXB tới các cấp quản lý địa phương trong quá trình tiếp cận chương trình giáo dục.
								</p>
							</div>
						</div>
						<div class="home-register__btns d-lg-block d-none">
							<a href="http://taphuan.nxbgd.vn" class="btn btn-main-light font-size-16 font-sanpro-semibold full-width border-rd-10 display-flex-center justify-content-center" target="_blank">
								Chuyển đến tập huấn
							</a>
						</div>
					</div>
				</div>
				<div class="home-register__banner home-section__large position-rel">
					<figure class="img-main margin-0 position-rel border-0">
						<img src="@/assets/images/home-training-new.png" alt="Tập huấn">
					</figure>
					<div class="home-register__btns d-lg-none d-md-block" style="margin-top: 40px;">
							<a href="http://taphuan.nxbgd.vn" class="btn btn-main-light font-size-16 font-sanpro-semibold full-width border-rd-10 display-flex-center justify-content-center" target="_blank">
								Chuyển đến tập huấn
							</a>
						</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
  	import { mapActions, mapState } from 'vuex'
  	import { videoPlayer } from 'vue-video-player'
  	import 'video.js/dist/video-js.css'
  	import JWT from "@/utils/jwt"
  	import { EMAIL_PUBLIC, PASS_PUBLIC } from '@/store/auth/constants'
  	import Register from '@/views/auth/Register'
  	import { STORE_KEY } from '@/modules/home/_store/constants'
	import store from '@/modules/home/_store'
	import { scrollTo } from '@/helpers/functions'
	import { APP_CONFIG } from '@/utils/constants'
	// import videoLink = require('@/assets/video/video-home.mp4')
	import VueSlickCarousel from 'vue-slick-carousel'
	import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  // optional style for arrows & dots
  	import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
	const OFFSET = 60

	export default {
		name: 'Home',
		components: {
			Register,
			videoPlayer,
			ModalRegister: () => import("@/views/auth/ModalRegister.vue"),
			VueSlickCarousel
			// HomePageSlide
		},
		data(){
			return{
				authInfo:{},
				tabIndex: 0,
				lastScrollPosition: 0,
				isShowImg: 0,
				isAuthorize: JWT.getAccessToken(),
				isOpenFormAuth: false,
				bookCdnUrl: APP_CONFIG.bookCdnUrl,
				playerOptions: {
					muted: true,
					language: 'en',
					autoplay: true,
					playbackRates: [0.7, 1.0, 1.5, 2.0],
					width: '100%',
					loop: true,
					sources: [{
						type: "video/mp4",
						src: `${APP_CONFIG.cdnLive}uploads/video-home-new.mp4`
					}],
					// poster: "/static/images/author.jpg",
				},
				settings:{
					"dots": true,
					"infinite": true,
					"slidesToShow": 1,
					"slidesToScroll": 1,
					"autoplay": true,
					"autoplaySpeed": 5000,
					"speed": 2000,
					"pauseOnHover":false
					},
				cdnLinkBanner: `${APP_CONFIG.cdnLive}uploads/banner/`,
			}
		},
		watch: {
			tabIndex(newVal){
				this.isShowImg = 0
			}
		},
		created() {
			if (!(STORE_KEY in this.$store._modules.root._children)) {
				this.$store.registerModule(STORE_KEY, store);
			}
		},
		mounted(){
			this.checkDirectPage()
			this.lastScrollPosition = window.pageYOffset
    		window.addEventListener('scroll', this.onScroll)
		},
		beforeDestroy () {
			window.removeEventListener('scroll', this.onScroll)
		},
		computed: {
			...mapState('auth', ['isAccFreeLogout']),
	        screenWidth () {
           		return window.innerWidth;
        	},
		},
		methods: {
			...mapActions(`auth`, ['authLogin', 'setAccFreeLogout']),

			mouseOver1() {
				this.isShowImg = 1
			},
			mouseOver2() {
				this.isShowImg = 2
			},
			onScroll () {
				if (window.pageYOffset < 0) {
					return
				}
				if (Math.abs(window.pageYOffset - this.lastScrollPosition) < OFFSET) {
					return
				}
				this.lastScrollPosition = window.pageYOffset
			},

			checkDirectPage() {
				let urlSearchDecode = decodeURIComponent(window.location.search.replace('?redirect=%2Fsach-dien-tu', ''));
				let urlParams = new URLSearchParams(urlSearchDecode);
				let classFilter = urlParams.get('classes');
				let tabFilter = urlParams.get('book_active');
				this.authInfo = JWT.getAuth()
				if(this.isAuthorize && this.authInfo.email != EMAIL_PUBLIC){
					this.$router.replace({ name: 'ebook', params: {classes: classFilter, book_active: tabFilter}, query: {classes: classFilter, book_active: tabFilter} })
				} else {
					let queryRouterCurr = this.$router.history.current.query;
					if(queryRouterCurr.redirect && (classFilter || tabFilter)) {
						let dataRouterTo = {query: {classes: classFilter, book_active: parseInt(tabFilter)}}
						this.loginFast(dataRouterTo);
					}
				}
			},

			toggleFormAuth() {
				this.isOpenFormAuth = !this.isOpenFormAuth;
				this.isAccFreeLogout && this.setAccFreeLogout(false);
			},

			loginFast(routerTo = null) {
				var postData={
					username: EMAIL_PUBLIC,
					password: PASS_PUBLIC,
					router_to: routerTo
				}
				this.authLogin(postData);
			},

			scrollToSection(id) {
				const elem = document.getElementById(id)
				const topPos = elem.offsetTop
				scrollTo(document.getElementsByTagName('html')[0], topPos, 600)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.btn-move-down, .btn-move-up{
		height: 50px;
		width: 50px;
		border-radius: 50%;
		border: 0;
		position: fixed;
		right: 32px;
		bottom: 32px;
		z-index: 2;
		background: #F3F6FB;
		i{
			line-height: 50px;
		}
		@media screen and (max-width: 768px){
			display: none;
		}
	}
	.btn-move-up{
		bottom: 42px;
	}
	.landingpage-1{
		position: relative;
		.class-2{
			&__image{
				transition: .3s;
				img{
					transition: .3s;
				}
			}
			&__title{
				margin-top: 10px;
			}
		}
		.books{
			margin-top: 32px;
			&__info{
				width: 50%;
				cursor: pointer;
			}
			&__try{
				padding-bottom: 15px;;
			}
			&__image{
				// margin-bottom: 16px;
				@media screen and (max-width: 575px){
					width: 150px;
				}
				@media screen and (max-width: 375px){
					width: 100px;
				}
			}
			&__title{
				margin-bottom: 24px;
				@media screen and (max-width: 575px){
					font-size: 18px;
				}
				@media screen and (max-width: 375px){
					font-size: 16px;
				}
			}
			.btn-try{
				background: none;
				border: 0;
				border-radius: 20px;
				height: 35px;
				padding: 0 15px;
				line-height: 35px;
				transition: .3s;
			}
			.info-1{
				&:hover{
					.books_try{
						.btn-try{
							color: #FFF !important;
							background: #0F3DBA;
						}
					}
				}
			}
			.info-2{
				&:hover{
					.books_try{
						.btn-try{
							color: #FFF !important;
							background: #0F3DBA;
						}
					}
				}
			}

		}
	}

	h1{
		font-size: 32px;
	}
	h2{
		font-size: 28px;
	}
	.css-img{
		max-height: 133px;
	}
	.btn__auth {
		background: #ddecfe;
		border-radius: 24px;
		color: #163fb3;
		line-height: 24px;
		padding: 2px 20px;
		display: inline-block;
		margin-right: 12px;
		font-size: 13px;
		font-weight: 500;

		&:hover, &.active {
			background: #163fb3;
			color: #fff;
			text-decoration: none;

			&:before {
				border: none;
			}
		}
	}

	video {
		max-width: 100%;
	}

	p {
		color: #879AA9;
	}

	.btn-trial2, .btn-trial2:hover{
	    background: #E1EFFF;
	    border-radius: 10px;
	    font-weight: bold;
	    letter-spacing: 1px;
	    padding: 10px 20px;
	    width: 100%;
	    text-align: center;
	    height: 44px;
	    color: #0F3DBA;
	}

	.home-register {
		&__form {
			max-width: 395px;
		}

		&__btns {
			.btn {
				height: 44px;

				&:not(:last-child) {
					margin-bottom: 20px;
				}
			}
		}
		&__desc {
			letter-spacing: 0.03em;

			&__title {
				margin-bottom: 33px;
			}

			&__content {
				margin-bottom: 70px;

				&__limit {
					margin-top: 15px;
				}
			}
		}

		&__bg {
			padding: 50px 0 50px 50px;
			// background: url('./../../../assets/images/bg-home-hts.png') no-repeat;
			// background-size: 125% 100%;
    		// background-position: right;
		}
	}
	.home-register {
		&__wrap {
			position: relative;
			padding: 40px 0;

			@media screen and ( min-width: 992px ) {
				min-height: calc(100vh - 75px);
			}
		}
	}

	.home-section {
		&__large {
			width: 57.5%;
		}

		&__small {
			width: 42.5%;
		}

		&__training {
			padding: 100px 32px 180px;
		}
	}

	.home-arrow {
		position: absolute;
		bottom: 10px;
		left: 0;
		right: 0;
		text-align: center;
	}
	@media screen and ( max-width: 991px ) {
		.home-arrow {
			display: none;
		}
		.home-section {
			&__large, &__small {
				width: 100%;
			}
		}
		.home-register {
			&__wrap {
				display: block;
			}

			&__bg {
				padding: 0;
				background: none;
			}

			&__form {
				max-width: 100%;
			}
		}
	}
	@media screen and ( min-width: 576px ) and ( max-width: 991px ) {
		.home-section {
			&__training {
				padding: 90px 0;
			}
		}
	}
	@media screen and ( max-width: 575px ) {
		.home-section {
			&__training {
				padding: 60px 0;
			}
		}

		.home-register {
			&__desc {
				&__title {
					font-size: 24px;
				}

				&__content {
					margin-bottom: 40px;

					p {
						font-size: 16px;
					}
				}
			}
		}

		// .book-group {
		// 	display: block;
		// 	.books__info {
		// 		width: 90%;
		// 		margin: 0 auto 20px;
		// 	}
		// }
	}
</style>